module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.pageTitle,
      "visible": _vm.showDialog,
      "show-close": false
    }
  }, [_c('el-form', {
    ref: "reviewForm",
    staticClass: "has-disabledField",
    attrs: {
      "model": _vm.reviewForm,
      "rules": _vm.rules,
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否复议",
      "prop": "type",
      "error": _vm.error.type,
      "required": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.reviewForm.type),
      callback: function($$v) {
        _vm.$set(_vm.reviewForm, "type", $$v)
      },
      expression: "reviewForm.type"
    }
  }, _vm._l((_vm.reviewType), function(o) {
    return _c('el-option', {
      key: o.value,
      attrs: {
        "label": o.name,
        "value": o.value
      }
    })
  }), 1)], 1), _vm._v(" "), (false) ? _c('el-form-item', {
    attrs: {
      "label": "建议金额",
      "prop": "advicePrice",
      "error": _vm.error.advicePrice,
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.reviewForm.advicePrice),
      callback: function($$v) {
        _vm.$set(_vm.reviewForm, "advicePrice", $$v)
      },
      expression: "reviewForm.advicePrice"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("元")])], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.reviewForm.type == 1) ? _c('el-form-item', {
    attrs: {
      "label": "退回节点",
      "prop": "backNode",
      "error": _vm.error.backNode,
      "required": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.reviewForm.backNode),
      callback: function($$v) {
        _vm.$set(_vm.reviewForm, "backNode", $$v)
      },
      expression: "reviewForm.backNode"
    }
  }, _vm._l((_vm.backNodeList), function(item) {
    return _c('el-option', {
      key: item.order_node_id,
      attrs: {
        "value": item.order_node_id,
        "label": item.node_name
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.reviewForm.type == 1) ? _c('el-form-item', {
    attrs: {
      "label": "建议原因",
      "prop": "mark",
      "error": _vm.error.mark,
      "required": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.reviewForm.mark),
      callback: function($$v) {
        _vm.$set(_vm.reviewForm, "mark", $$v)
      },
      expression: "reviewForm.mark"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-daaf9aae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/part/car/formTpl/storeReviewWin.vue
// module id = 1306
// module chunks = 105